import { extends as _extends } from '../../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Field } from 'react-final-form';
import { OptionGroup, Label, OptionLabel, Input, LabelText, ErrorText } from '../Form.styles.js';

var Radio = function Radio(_ref) {
  var name = _ref.name,
    label = _ref.label,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [{
      displayName: null
    }] : _ref$options,
    _ref$validations = _ref.validations,
    validations = _ref$validations === void 0 ? null : _ref$validations;
  return /*#__PURE__*/React.createElement(OptionGroup, {
    gridArea: name
  }, /*#__PURE__*/React.createElement(Label, {
    className: "label radio-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "options_".concat(name)
  }, options.map(function (_ref2, index) {
    var displayName = _ref2.displayName,
      value = _ref2.value,
      optionLabel = _ref2.label,
      optionName = _ref2.name;
    return /*#__PURE__*/React.createElement(Field, {
      key: displayName || optionLabel,
      name: name,
      validate: validations,
      type: "radio",
      value: value
    }, function (_ref3) {
      var input = _ref3.input,
        meta = _ref3.meta;
      return /*#__PURE__*/React.createElement(OptionLabel, {
        gridArea: optionName
      }, /*#__PURE__*/React.createElement(Input, _extends({}, input, {
        "aria-invalid": Boolean(meta.touched && meta.error)
      })), /*#__PURE__*/React.createElement(LabelText, null, displayName || optionLabel), meta.error && meta.touched && index === options.length - 1 && /*#__PURE__*/React.createElement(ErrorText, {
        className: "error-text"
      }, meta.error));
    });
  })));
};
var Radio$1 = Radio;

export { Radio$1 as default };
//# sourceMappingURL=Radio.js.map
